export class FileUpload {
    
      $key: string;
      name: string;
      url: string;
      file: File;
    
      constructor(file: File) {
        this.file = file;
        this.url="null";
        this.name="null";
      }
      
    }


// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/interfaces/fileupload.ts